import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import CityNameListData from "./property-data.json";

export default function HeroSearchForm() {
    const [CityNameList] = useState(CityNameListData);
    return (
        <>
            <Form className='hero-search-input'>
                <Row className='gx-2'>
                    <Col md={10}>
                        <Row className='gx-2'>
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    <i className="bi bi-geo input-icon-s text-primary"></i>
                                    <Form.Select aria-label="Default select example">
                                        <option>Location</option>
                                        {CityNameList.heroCityName.map((data, i) =>
                                            <option key={i} value={`${data.cityNameValue}`}>{data.cityName}</option>
                                        )}
                                    </Form.Select>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    <i className="bi bi-house input-icon-s text-primary"></i>
                                    <Form.Select aria-label="Default select example">
                                        <option>Property</option>
                                        <option value="1">Land</option>
                                        <option value="2">Residential</option>
                                        <option value="3">Commercial</option>
                                        <option value="3">Industrial</option>
                                    </Form.Select>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    <i className="bi bi-currency-dollar input-icon-s text-primary"></i>
                                    <Form.Select aria-label="Default select example">
                                        <option>Price</option>
                                        <option value="1">$500.00 - $1000.00</option>
                                        <option value="2">$1000.00 - $5000.00</option>
                                        <option value="3">$5000.00 - $10000.00</option>
                                    </Form.Select>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={2}>
                        <Button variant="primary w-100"><i className="bi bi-search"></i> <span className='d-none d-xxl-inline-block ms-2'>Search</span></Button>
                    </Col>
                </Row>
            </Form>
        </>
    )
}
